import {useParams} from "react-router-dom";
import HeaderPortfolioDetail from "../components/landingPages/PortfolioDetail/HeaderPortfolioDetail";
import LandingPageWidget from "../widget/LandingPageWidget";
import ProjectDescription from "../components/landingPages/PortfolioDetail/ProjectDescription";
import CarouselComponent from "../components/landingPages/PortfolioDetail/CarouselComponent";
import TechnologiesUsed from "../components/landingPages/PortfolioDetail/TechnologiesUsed";
import BreadcrumbsComponent from "../components/BreadcrumbsComponent";
import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../Context/GlobalContext";
import SpinnerLoading from "../components/loadings/SpinnerLoading";
import Aos from "aos";
import "aos/dist/aos.css";

const linkList = [
    {
        name: "Home",
        linkUrl: "/"
    },
    {
        name: "Portfolio",
        linkUrl: "/portfolios"
    },
    {
        name: "Detail",
        linkUrl: "/"
    }
]

const PortfolioDetail = () => {
    const {id} = useParams();
    const {functionContext, stateContext} = useContext(GlobalContext);
    const {portfolioDetail} = stateContext;
    const {fetchPortfolioByIdApi} = functionContext;
    const [isLoading, setIsLoading] = useState(true);
    
    useEffect(() => {
        Aos.init({ duration: 1500, once: true });
        fetchPortfolioByIdApi(id, () => {
            setIsLoading(false);
        });
    },[id])
    
    return(
        <LandingPageWidget>
            {/* Loading state */}
            {isLoading && (
                <div className="min-h-screen bg-slate-50 dark:bg-slate-900 transition-colors duration-300 flex items-center justify-center">
                    <SpinnerLoading text={'Loading project details...'} />
                </div>
            )}

            {/* Content */}
            {!isLoading && portfolioDetail && (
                <>
                    <HeaderPortfolioDetail text={portfolioDetail.title} />
                    
                    {/* Main content with modern layout */}
                    <div className="bg-slate-50 dark:bg-slate-900 min-h-screen relative overflow-hidden transition-colors duration-300">
                        {/* Subtle separator line top */}
                        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-slate-700 to-transparent"></div>
                        
                        <div className="container mx-auto px-6 lg:px-8 py-12 relative z-10">
                            <div className="max-w-6xl mx-auto space-y-12">
                                {/* Breadcrumbs */}
                                <div data-aos="fade-down">
                                    <BreadcrumbsComponent linkList={linkList} />
                                </div>

                                {/* Hero Image */}
                                <div className="relative group" data-aos="fade-up" data-aos-delay="100">
                                    <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-3xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300">
                                        <img 
                                            src={portfolioDetail.photoUrl} 
                                            alt={portfolioDetail.title}
                                            className="w-full h-96 lg:h-[500px] object-cover transition-transform duration-700 group-hover:scale-105"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                                    </div>
                                </div>

                                {/* Content Grid */}
                                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
                                    {/* Main Content */}
                                    <div className="lg:col-span-2">
                                        <div data-aos="fade-right" data-aos-delay="200">
                                            <ProjectDescription 
                                                description={portfolioDetail.description} 
                                                linkProject={portfolioDetail.link} 
                                            />
                                        </div>
                                    </div>
                                    
                                    {/* Sidebar */}
                                    <div className="lg:col-span-1" data-aos="fade-left" data-aos-delay="250">
                                        <TechnologiesUsed tags={portfolioDetail.portfolioTechs} />
                                    </div>
                                </div>

                                {/* Full Width Gallery */}
                                <div className="w-full mt-12" data-aos="fade-up" data-aos-delay="300">
                                    <CarouselComponent photos={portfolioDetail.portfolioPhotos}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            
            {/* Error state */}
            {!isLoading && !portfolioDetail && (
                <div className="min-h-screen bg-slate-50 dark:bg-slate-900 transition-colors duration-300 flex items-center justify-center">
                    <div className="text-center space-y-4">
                        <div className="w-16 h-16 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mx-auto">
                            <svg className="w-8 h-8 text-slate-400 dark:text-slate-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-slate-700 dark:text-slate-200">Project Not Found</h2>
                        <p className="text-slate-500 dark:text-slate-400">The project you're looking for doesn't exist.</p>
                    </div>
                </div>
            )}
        </LandingPageWidget>
    )
}
export default PortfolioDetail;